import React from "react";
import { FaEthereum, FaShieldAlt, FaFileContract, FaLock } from "react-icons/fa";

const CreateEscrow = ({
  seller,
  setSeller,
  amount,
  setAmount,
  selectedToken,
  setSelectedToken,
  tokens,
  createEscrow,
  isLoading
}) => {
  return (
    <div className="bg-gray-800 bg-opacity-50 rounded-xl p-8 shadow-2xl border border-gray-700 mb-10">
      <div className="flex flex-col md:flex-row items-start gap-8">
        <div className="w-full md:w-1/2">
          <h2 className="text-2xl font-bold mb-6 bg-gradient-to-r from-green-400 to-blue-500 text-transparent bg-clip-text">
            Create New Secure Transaction
          </h2>
          
          <form className="space-y-6">
            <div className="space-y-2">
              <label className="block text-gray-300 text-sm font-medium">Select Token</label>
              <div className="relative">
                <select
                  value={selectedToken}
                  onChange={(e) => setSelectedToken(e.target.value)}
                  className="block w-full px-4 py-3 border border-gray-600 rounded-lg bg-gray-700 text-white shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-500 focus:ring-opacity-50"
                >
                  {tokens.map(({ name, address }) => (
                    <option key={address} value={address}>
                      {name}
                    </option>
                  ))}
                </select>
                <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                  <FaEthereum className="text-blue-400" />
                </div>
              </div>
              <p className="text-xs text-gray-400">Select the token you want to use for this transaction</p>
            </div>
            
            <div className="space-y-2">
              <label className="block text-gray-300 text-sm font-medium">Recipient Address</label>
              <input
                type="text"
                placeholder="0x..."
                value={seller}
                onChange={(e) => setSeller(e.target.value)}
                className="block w-full px-4 py-3 border border-gray-600 rounded-lg bg-gray-700 text-white shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-500 focus:ring-opacity-50"
              />
              <p className="text-xs text-gray-400">Enter the wallet address of the recipient</p>
            </div>
            
            <div className="space-y-2">
              <label className="block text-gray-300 text-sm font-medium">Amount</label>
              <div className="relative">
                <input
                  type="number"
                  placeholder="0.00"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  className="block w-full px-4 py-3 border border-gray-600 rounded-lg bg-gray-700 text-white shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-500 focus:ring-opacity-50"
                />
                <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                  <span className="text-gray-400">
                    {tokens.find(t => t.address === selectedToken)?.name || "TOKEN"}
                  </span>
                </div>
              </div>
              <p className="text-xs text-gray-400">Enter the amount to be held in escrow</p>
            </div>
            
            <button
              type="button"
              onClick={createEscrow}
              disabled={isLoading}
              className="w-full flex items-center justify-center px-6 py-3 bg-gradient-to-r from-green-500 to-blue-600 hover:from-green-600 hover:to-blue-700 text-white font-semibold rounded-lg transition-all duration-300"
            >
              {isLoading ? (
                <>
                  <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Processing...
                </>
              ) : (
                <>
                  <FaShieldAlt className="mr-2" />
                  Create Secure Transaction
                </>
              )}
            </button>
          </form>
        </div>
        
        <div className="w-full md:w-1/2 bg-gray-900 bg-opacity-50 p-6 rounded-xl border border-gray-700">
          <h3 className="text-xl font-semibold mb-4 text-white">How It Works</h3>
          
          <div className="space-y-4">
            <div className="flex items-start space-x-3">
              <div className="flex-shrink-0 mt-1">
                <div className="bg-gradient-to-br from-green-500 to-blue-600 w-8 h-8 rounded-lg flex items-center justify-center">
                  <FaFileContract className="text-white" />
                </div>
              </div>
              <div>
                <h4 className="text-white font-medium">1. Create Transaction</h4>
                <p className="text-gray-400 text-sm">Enter recipient's address and amount to create a secure escrow contract.</p>
              </div>
            </div>
            
            <div className="flex items-start space-x-3">
              <div className="flex-shrink-0 mt-1">
                <div className="bg-gradient-to-br from-green-500 to-blue-600 w-8 h-8 rounded-lg flex items-center justify-center">
                  <FaLock className="text-white" />
                </div>
              </div>
              <div>
                <h4 className="text-white font-medium">2. Funds Secured</h4>
                <p className="text-gray-400 text-sm">Your funds are locked in a smart contract until all parties are satisfied.</p>
              </div>
            </div>
            
            <div className="flex items-start space-x-3">
              <div className="flex-shrink-0 mt-1">
                <div className="bg-gradient-to-br from-green-500 to-blue-600 w-8 h-8 rounded-lg flex items-center justify-center">
                  <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
              </div>
              <div>
                <h4 className="text-white font-medium">3. Approve Release</h4>
                <p className="text-gray-400 text-sm">Once conditions are met, you approve the release of funds to the recipient.</p>
              </div>
            </div>
            
            <div className="mt-6 text-gray-400 text-sm border-t border-gray-700 pt-4">
              <p className="mb-2">
                <span className="text-yellow-400">⚠️ Important:</span> The payment will be stored in a secure blockchain-based smart contract.
              </p>
              <p>
                If a dispute arises, our trusted arbitration service will help resolve the issue fairly for all parties involved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateEscrow;